<template>
  <modal name="neocareer-dialog" :adaptive="true" :scrollable="true" height="auto" :clickToClose="true" @before-close="handleBeforeClose">
    <div class="v--modal-close-top" v-loading.fullscreen.lock="fullscreenLoading">
      <el-button @click="closeNeocareerDialog" icon="el-icon-circle-close" style="font-size: 2rem;"
        type="text"></el-button>
    </div>
    <div class="setting" v-if="false">

      <div style="text-align: center;">
        <!--企業ロゴ-->
        <div style="display: inline-block; min-width: 100%; text-align: center; padding: 10px;">
          <img src="/static/renew_img/noecareer_yagish_logo.png" style="max-width: 90%;">
        </div>

        <p style="margin-bottom: 10px;">ダウンロードが完了しました！</p>
        <p style="margin-bottom: 10px;">いま作成した履歴書を使って就活の無料相談をしてみよう！</p>

        <!--オススメリスト-->
        <div style="display: inline-block; min-width: 100%; text-align: center; margin-bottom: 20px;">
          <div
            style="text-align: left; margin-left: 0.5rem; font-size: 120%; font-weight: bold; line-height: 1.3; margin-bottom: 20px;">
            <div style="padding-bottom: 10px; display: flex; align-items: center;">
              <p
                style="display: block; background:#0F9934; width: 20px; height: 20px; border-radius: 50%; margin-right: 10px;">
              </p>
              <p style="font-size: 120%; font-weight: bold;">就活のプロが最強の履歴書作成をサポート！</p>
            </div>
            <div style="padding-bottom: 10px; display: flex; align-items: center;">
              <p
                style="display: block; background:#0F9934; width: 20px; height: 20px; border-radius: 50%; margin-right: 10px;">
              </p>
              <p style="font-size: 120%; font-weight: bold;">あなたに合った企業を全国からご提案！</p>
            </div>
            <div style="display: flex; align-items: center;">
              <p
                style="display: block; background:#0F9934; width: 20px; height: 20px; border-radius: 50%; margin-right: 10px;">
              </p>
              <p style="font-size: 120%; font-weight: bold;">最短2週間で内定できちゃう！</p>
            </div>
          </div>
        </div>

        <br>

        <div style="margin-bottom: 40px;"><!--規約等とボタンのセット-->
          <!--ここにチェックボックス入れる-->
          <p style="padding-bottom: 5px;font-size: 80%;">
            <el-checkbox v-model="isAgree"
              style="-moz-transform: scale(1.4);-webkit-transform:	scale(1.4);transform:		scale(1.4);">
            </el-checkbox>
            利用規約・個人情報の取り扱いについてに同意する
          </p>
          <div style="width: 90%; margin: 0 auto;">
            <!--<p style="font-size: 120%; font-weight: bold; padding-right: 15px;">看護師を希望</p>-->

            <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success"
              v-if="isNeocareerSended == false && isAgree == false"
              style="background-color: rgb(255, 255, 255); border-color: rgb(246, 11, 38); font-size: 120%;color:rgb(0, 0, 0)"
              @click="$eventHub.$emit('send-neocareer-consult');"><span
                style="font-size: 80%; line-height: 1rem;">無料相談を希望する</span></el-button>
            <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success"
              v-else-if="isNeocareerSended == false && isAgree == true"
              style="background-color: rgb(246, 11, 38); border-color: rgb(246, 11, 38); font-size: 120%;"
              @click="$eventHub.$emit('send-neocareer-consult');"><span
                style="font-size: 80%; line-height: 1rem;">無料相談を希望する</span></el-button>
            <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success"
              v-else-if="isNeocareerSended == true" style="background-color:#0F9934;border-color:#0F9934;"
              @click="closeNeocareerDialog();"><span
                style="font-size: 80%; line-height: 1rem;">送信しました</span></el-button>

          </div>
        </div>

        <p>
          Yagishの<router-link id="footer-link-terms" :to="{ name: 'termsPage' }"
            target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{ name: 'policyPage' }"
            target="_blank">個人情報保護方針</router-link>、<a href="https://www.yagish.jp/privacy_policy/"
            target="_blank">プライバシーポリシー</a><br />
          株式会社ネオキャリアの<a href="https://www.s-agent.jp/agreement" target="_blank">利用規約</a>、<a
            href="https://www.neo-career.co.jp/policy/" target="_blank">個人情報の取り扱いについて</a>
        </p>

      </div>

    </div>
    <div id="renew2_popup" v-if="permissionType == 11">
      <div class="popup_block">
        <img src="/static/dialog_img/popup01.png" alt="24卒で頑張っているあなたに！" style="width: 100%;">
        <div class="popup_item">

          <div style="text-align:center; background: #F7F7F7; padding: 10px; margin-top: 10px;"
            :id="!$globalVar.googleAdsTagCheck(clientId, permissionType) ? 'pdf-' + $globalVar.dn_flag + '-rt-completed' : clientId + '_' + permissionType + '_btn'"
            @click="$eventHub.$emit('send-neocareer-consult');">
            <div class="company_merit">
              <img src="/static/dialog_img/logo_agentneo.png" alt="エージェントネオ">
              <img src="/static/dialog_img/list01_neo24.png" alt="最短２週間で内定・無料相談">
            </div>

            <div class="consent">
              <p class="consent_check">
                <el-checkbox v-model="isAgree"
                  style="-moz-transform: scale(1.4);-webkit-transform:	scale(1.4);transform:		scale(1.4);">
                </el-checkbox>
                <span class="el-checkbox__label consent_check_label">利用規約・個人情報の取り扱いについてに同意する</span>
              </p>
            </div>
          </div>

          <div class="consent_btn_block">
            <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success"
              v-if="isNeocareerSended == false && isAgree == false"
              style="background-color: rgb(255, 255, 255); border-color: rgb(246, 11, 38); font-size: 120%;color:rgb(0, 0, 0)"
              @click="$eventHub.$emit('send-neocareer-consult');"><span
                style="font-size: 80%; line-height: 1rem; padding: 20px;">話を聞いてみる</span></el-button>
            <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success"
              v-else-if="isNeocareerSended == false && isAgree == true"
              style="background-color: rgb(246, 11, 38); border-color: rgb(246, 11, 38); font-size: 120%;"
              @click="$eventHub.$emit('send-neocareer-consult');"><span
                style="font-size: 80%; line-height: 1rem; padding: 20px;">話を聞いてみる</span></el-button>
            <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success"
              v-else-if="isNeocareerSended == true" style="background-color:#0F9934;border-color:#0F9934;"
              @click="closeNeocareerDialog();"><span
                style="font-size: 80%; line-height: 1rem;">送信しました</span></el-button>
          </div>

          <p class="terms_txt">(株)Yagishの<a href="/terms" id="footer-link-terms" target="_blank">利用規約</a>、<a
              href="/privacy" id="footer-link-policy" target="_blank">個人情報保護方針</a><br>株式会社ネオキャリアの<a
              href="https://www.s-agent.jp/agreement" target="_blank">利用規約</a>、<a
              href="https://www.neo-career.co.jp/policy/" target="_blank">個人情報の取り扱いについて</a></p>
        </div>
        <img src="/static/dialog_img/popup02.png" alt="ここまで書いたあなたはスゴいッ！えらいッ！">
      </div>
    </div>

    <div id="renew2_popup" v-if="permissionType == 2">
      <div class="popup_block">
        <img src="/static/dialog_img/popup_neo24.png" alt="24卒で頑張っているあなたに！" style="width: 100%;">
        <div class="popup_item">

          <div style="text-align:center; background: #F7F7F7; padding: 10px; margin-top: 10px;"
            :id="!$globalVar.googleAdsTagCheck(clientId, permissionType) ? 'pdf-' + $globalVar.dn_flag + '-rt-completed' : clientId + '_' + permissionType + '_btn'"
            @click="$eventHub.$emit('send-neocareer-consult');">
            <div class="company_merit">
              <img src="/static/dialog_img/logo_agentneo.png" alt="エージェントネオ">
              <img src="/static/dialog_img/list01_neo24.png" alt="最短２週間で内定・無料相談">
            </div>

            <div class="consent">
              <p class="consent_check">
                <el-checkbox v-model="isAgree"
                  style="-moz-transform: scale(1.4);-webkit-transform:	scale(1.4);transform:		scale(1.4);">
                </el-checkbox>
                <span class="el-checkbox__label consent_check_label">利用規約・個人情報の取り扱いについてに同意する</span>
              </p>
            </div>
          </div>

          <div class="consent_btn_block" v-if="!$globalVar.googleAdsTagCheck(clientId, permissionType)">
            <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success"
              v-if="isNeocareerSended == false && isAgree == false"
              style="background-color: rgb(255, 255, 255); border-color: rgb(246, 11, 38); font-size: 120%;color:rgb(0, 0, 0)"
              @click="$eventHub.$emit('send-neocareer-consult');"><span
                style="font-size: 80%; line-height: 1rem; padding: 20px;">話を聞いてみる</span></el-button>
            <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success"
              v-else-if="isNeocareerSended == false && isAgree == true"
              style="background-color: rgb(246, 11, 38); border-color: rgb(246, 11, 38); font-size: 120%;"
              @click="$eventHub.$emit('send-neocareer-consult');"><span
                style="font-size: 80%; line-height: 1rem; padding: 20px;">話を聞いてみる</span></el-button>
            <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success"
              v-else-if="isNeocareerSended == true" style="background-color:#0F9934;border-color:#0F9934;"
              @click="closeNeocareerDialog();"><span
                style="font-size: 80%; line-height: 1rem;">送信しました</span></el-button>
          </div>
          <div class="consent_btn_block" v-else>
            <el-button :id="clientId + '_' + permissionType + '_btn'" type="success"
              v-if="isNeocareerSended == false && isAgree == false"
              style="background-color: rgb(255, 255, 255); border-color: rgb(246, 11, 38); font-size: 120%;color:rgb(0, 0, 0)"
              @click="$eventHub.$emit('send-neocareer-consult');"><span
                style="font-size: 80%; line-height: 1rem; padding: 20px;">話を聞いてみる</span></el-button>
            <el-button :id="clientId + '_' + permissionType + '_btn'" type="success"
              v-else-if="isNeocareerSended == false && isAgree == true"
              style="background-color: rgb(246, 11, 38); border-color: rgb(246, 11, 38); font-size: 120%;"
              @click="$eventHub.$emit('send-neocareer-consult');"><span
                style="font-size: 80%; line-height: 1rem; padding: 20px;">話を聞いてみる</span></el-button>
            <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success"
              v-else-if="isNeocareerSended == true" style="background-color:#0F9934;border-color:#0F9934;"
              @click="closeNeocareerDialog();"><span
                style="font-size: 80%; line-height: 1rem;">送信しました</span></el-button>
          </div>

          <div style="margin-top: 20px; text-align: center;">
            <p style="font-size: 10px;" class="terms_txt">(株)Yagishの<a href="/terms" id="footer-link-terms"
                target="_blank">利用規約</a>、<a href="/privacy" id="footer-link-policy"
                target="_blank">個人情報保護方針</a><br>株式会社ネオキャリアの<a href="https://www.s-agent.jp/agreement"
                target="_blank">利用規約</a>、<a href="https://www.neo-career.co.jp/policy/"
                target="_blank">個人情報の取り扱いについて</a>を
              <br>確認して就職Agent neoに登録することになります。
            </p>
          </div>

        </div>
        <img src="/static/dialog_img/popup02.png" alt="ここまで書いたあなたはスゴいッ！えらいッ！">
      </div>
    </div>

    <div class="setting" v-if="permissionType == 3 || permissionType == 1 || permissionType == 5">
      <div class="setting-item" style="text-align: center;">
        <p style="font-size: 16px; font-weight: bold; margin-bottom: 10px;text-align: center;">ダウンロードが完了しました！！！</p>
        <p style="font-size: 16px; font-weight: bold;text-align: center;">今作成した履歴書をもとに<br class="sp">プロが好条件の勤め先をご紹介します！
        </p>

        <div style="text-align:center; background: #F7F7F7; padding: 10px; margin-top: 10px;"
          :id="!$globalVar.googleAdsTagCheck(clientId, permissionType) ? 'pdf-' + $globalVar.dn_flag + '-rt-completed' : clientId + '_' + permissionType + '_btn'"
          @click="$eventHub.$emit('send-neocareer-consult');">
          <p style="text-align: center; margin: 20px 0;">
            <img src="/static/renew2_img/neoe_yagish_logo_20230704.png" alt="ネオキャリアとヤギッシュ" style="width: 90%;">
          </p>

          <p style="font-size: 16px; font-weight: bold; color: rgb(227, 22, 92);">
            <img src="/static/renew_img/check_icon.png"
              style="position: relative; height: 16px; top: -5px;">規約に同意して無料相談を希望する
          </p>
        </div>

        <div class="text-center" v-if="!$globalVar.googleAdsTagCheck(clientId, permissionType)">
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success"
            v-if="isNeocareerSended == false"
            style="background: none; border: none; padding: 20px 0; margin-top: -20px; width: 100%;"
            @click="$eventHub.$emit('send-neocareer-consult');"><span
              style="font-size: 18px; font-weight: bold; margin-top: 0; display: block; width: 100%; background: rgb(227, 22, 92); border: rgb(227, 22, 92); padding: 20px; border-radius: 4px;">同意する</span></el-button>
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success"
            v-if="isNeocareerSended == true" style="background-color:#0F9934;border-color:#0F9934;"
            @click="closeNeocareerDialog();">送信しました</el-button>
          <br>
        </div>
        <div class="text-center" v-else>
          <el-button :id="clientId + '_' + permissionType + '_btn'" type="success" v-if="isNeocareerSended == false"
            style="background: none; border: none; padding: 20px 0; margin-top: -20px; width: 100%;"
            @click="$eventHub.$emit('send-neocareer-consult');"><span
              style="font-size: 18px; font-weight: bold; margin-top: 0; display: block; width: 100%; background: rgb(227, 22, 92); border: rgb(227, 22, 92); padding: 20px; border-radius: 4px;">同意する</span></el-button>
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success"
            v-if="isNeocareerSended == true" style="background-color:#0F9934;border-color:#0F9934;"
            @click="closeNeocareerDialog();">送信しました</el-button>
          <br>
        </div>

        <div style="margin-top: 20px; text-align: center;">
          <p style="font-size: 10px;">
            Yagishの<router-link id="footer-link-terms" :to="{ name: 'termsPage' }"
              target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{ name: 'policyPage' }"
              target="_blank">個人情報保護方針</router-link>、<a href="https://www.yagish.jp/privacy_policy/"
              target="_blank">プライバシーポリシー</a><br />
            (株)ネオキャリアの<a href="https://www.s-agent.jp/agreement" target="_blank">利用規約</a>、<a
              href="https://www.neo-career.co.jp/policy/" target="_blank">個人情報の取り扱いについて</a>を
            <br>確認して就職Agent neoに登録することになります。
          </p>

          <p style="font-size: 10px;margin-top: 10px;">ご同意いただいた方には追って<br>連絡がいきますのでご確認お願いいたします！</p>
        </div>

      </div>

      <div class="setting-item" style="text-align: center;" v-if="false">
        <p>ダウンロードが完了しました！！！</p>
        <p style="font-size: 1rem; font-weight: bold;">今作成した履歴書をもとに<br>プロが好条件の勤め先をご紹介します！</p>

        <p style="display: inline-block; margin: 10px;">
          <img src="/static/renew2_img/neoe_yagish_logo_20230704.png" alt="ネオキャリアとヤギッシュ">
        </p>

        <p style="font-weight: bold;">ご同意いただいた方には追って<br>連絡がいきますのでご確認お願いいたします！</p>

        <p style="font-size: 0.8rem; padding: 5px;">
          Yagishの<router-link id="footer-link-terms" :to="{ name: 'termsPage' }"
            target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{ name: 'policyPage' }"
            target="_blank">個人情報保護方針</router-link>、<a href="https://www.yagish.jp/privacy_policy/"
            target="_blank">プライバシーポリシー</a><br />
          (株)ネオキャリアの<a href="https://www.s-agent.jp/agreement" target="_blank">利用規約</a>、<a
            href="https://www.neo-career.co.jp/policy/" target="_blank">個人情報の取り扱いについて</a>を
          <br>確認して就職Agent neoに登録することになります。
        </p>

        <p style="font-size: 1rem; font-weight: bold; margin-top: 10px;"><img src="/static/renew_img/check_icon.png"
            alt="同意する" style="height: 30px;">
          規約に同意して無料相談を希望する</p>

        <div class="text-center" v-if="!$globalVar.googleAdsTagCheck(clientId, permissionType)">
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success"
            v-if="isNeocareerSended == false"
            style="background-color: rgb(246, 11, 38); border-color: rgb(246, 11, 38); margin-top: 0;"
            @click="$eventHub.$emit('send-neocareer-consult');">同意する</el-button>
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success"
            v-if="isNeocareerSended == true" style="background-color:#0F9934;border-color:#0F9934;"
            @click="closeNeocareerDialog();">送信しました</el-button>
          <br>
        </div>
        <div class="text-center" v-else>
          <el-button :id="clientId + '_' + permissionType + '_btn'" type="success" v-if="isNeocareerSended == false"
            style="background-color: rgb(246, 11, 38); border-color: rgb(246, 11, 38); margin-top: 0;"
            @click="$eventHub.$emit('send-neocareer-consult');">同意する</el-button>
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success"
            v-if="isNeocareerSended == true" style="background-color:#0F9934;border-color:#0F9934;"
            @click="closeNeocareerDialog();">送信しました</el-button>
          <br>
        </div>
      </div>
    </div>

    <div class="setting" v-if="permissionType == 4">
      <div class="setting-item" style="text-align: center;">
        <p>ダウンロードが完了しました！！！</p>
        <p style="font-size: 1rem; font-weight: bold;">今作成した履歴書をもとに<br>プロが好条件の勤め先をご紹介します！</p>

        <div style="text-align:center; background: #F7F7F7; padding: 10px; margin-top: 10px;"
          :id="!$globalVar.googleAdsTagCheck(clientId, permissionType) ? 'pdf-' + $globalVar.dn_flag + '-rt-completed' : clientId + '_' + permissionType + '_btn'"
          @click="$eventHub.$emit('send-neocareer-consult');">
          <p style="display: inline-block; margin: 10px;">
            <img src="/static/renew2_img/neocareer_34_yagish_logo_20240405.png" alt="ネオキャリアとヤギッシュ">
          </p>

          <p style="font-size: 1rem; font-weight: bold; margin-top: 10px;"><img src="/static/renew_img/check_icon.png"
              alt="同意する" style="height: 30px;">
            規約に同意して無料相談を希望する</p>
        </div>

        <div class="text-center" v-if="!$globalVar.googleAdsTagCheck(clientId, permissionType)">
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success"
            v-if="isNeocareerSended == false"
            style="background-color: rgb(246, 11, 38); border-color: rgb(246, 11, 38); margin-top: 0; padding: 20px;"
            @click="$eventHub.$emit('send-neocareer-consult');">同意する</el-button>
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success"
            v-if="isNeocareerSended == true" style="background-color:#0F9934;border-color:#0F9934;"
            @click="closeNeocareerDialog();">送信しました</el-button>
          <br>
        </div>
        <div class="text-center" v-else>
          <el-button :id="clientId + '_' + permissionType + '_btn'" type="success" v-if="isNeocareerSended == false"
            style="background-color: rgb(246, 11, 38); border-color: rgb(246, 11, 38); margin-top: 0; padding: 20px;"
            @click="$eventHub.$emit('send-neocareer-consult');">同意する</el-button>
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success"
            v-if="isNeocareerSended == true" style="background-color:#0F9934;border-color:#0F9934;"
            @click="closeNeocareerDialog();">送信しました</el-button>
          <br>
        </div>

        <div style="margin-top: 20px; text-align: center;">
          <p style="font-size: 10px;">
            Yagishの<router-link id="footer-link-terms" :to="{ name: 'termsPage' }"
              target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{ name: 'policyPage' }"
              target="_blank">個人情報保護方針</router-link>、<a href="https://www.yagish.jp/privacy_policy/"
              target="_blank">プライバシーポリシー</a>と(株)ネオキャリアの<a href="https://hitoshia-hoiku.com/terms"
              target="_blank">利用規約</a>、<a href="https://hitoshia-hoiku.com/privacy" target="_blank">個人情報保護</a>を
            <br>確認してヒトシア保育に登録することになります。
          </p>

          <p style="font-size: 10px; margin-top: 10px;">ご同意いただいた方には追ってご連絡いたし<br>ますので、ご確認お願いいたします！</p>
        </div>

      </div>
    </div>
  </modal>
</template>

<style scoped>
#renew2_popup .popup_block {
  text-align: center;
}

#renew2_popup img {
  width: 50%;
  display: block;
  margin: 0 auto;
}

#renew2_popup .popup_item {
  background: #EEF5E8;
  padding: 20px;
  width: calc(100% + 80px);
  margin: 15px -40px;
}

#renew2_popup .company_merit {
  background: #fff;
  margin: 0 20px 20px;
  padding: 20px;
  border-radius: 10px;
}

#renew2_popup .terms_txt {
  text-align: left;
  margin: 20px;
  font-size: 0.8rem;
}

#renew2_popup .consent {
  display: inline-block;
  min-width: 100%;
  text-align: center;
  margin: 0 20px;
}

#renew2_popup .consent_check_label {
  font-weight: bold;
  font-size: 1rem;
  color: #004D40;
}

#renew2_popup .consent_btn_block {
  text-align: center;
}

#renew2_popup .consent_btn {
  background-color: rgb(227, 22, 92);
  border-color: rgb(227, 22, 92);
  border-radius: 35px;
  font-weight: bold;
}

#renew2_popup .consent_check {
  display: flex;
  align-items: center;
  margin-right: 40px;
}
</style>

<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<style lang="scss" src="@/assets/scss/pages/setting.scss"></style>
<script>
import { emitRtDialogClosedWithoutSubmit, wrapMittPopupHandler } from '@/plugins/emitter'
export default {
  components: {
  },
  data: function () {
    return {
      isMypage: false,
      clearLocalStorageConfirmVisible: false,
      currentFormat: {},
      formatid: '',
      previewHtml: '',
      permissionType: 1,
      isNeocareerSended: false,
      isMedlySended: false,
      isAdtopSended: false,
      clientId: 'neocareer_admin',
      isJigenSended: false,
      fullscreenLoading: false,
      username: '',
      baite_title: 'バイト',
      isAgree: false
    }
  },
  created: function () {
    const app = this
    this.$iterateStorage(function (value, key, iterationNumber) {
      // console.log all the kay/value pairs
      if (key === 'basicData') {
        app.username = value.lastName + '_' + value.firstName
      }
    }, function (err) {
      if (!err) {
        console.log('Iteration has completed')
      }
    })
  },
  computed: {
    cleanedPreviewHtml: function () {
      // PDFで文字化けするやつを変換しておく
      return this.previewHtml
    },
    pdfFormData: function () {
      const formData = new FormData()
      formData.append('app_html', this.cleanedPreviewHtml)
      formData.append('pdf_option', 'A4')
      return formData
    }
  },
  methods: {
    openNeocareerDialog: function (id, html, permissionType, gradeYear, isMypage = false) {
      this.isMypage = isMypage
      // if (gradeYear != 24) {
      //   this.closeNeocareerDialog()
      //   return
      // }
      this.formatid = id
      this.previewHtml = html.$el.innerHTML
      this.$modal.show('neocareer-dialog')
      this.clearLocalStorageConfirmVisible = false
      this.permissionType = permissionType
      if (this.permissionType == 1 || this.permissionType == 3 || this.permissionType == 4 || this.permissionType == 5 || this.permissionType == 6) {
        this.isAgree = true
      }
      // if (this.permissionType == 3 || this.permissionType == 4) {
      //   this.clientId = "hitoshia_admin"
      // }

      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('dialog_name', 'neocareer_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('version', '2')
      formData.append('is_mypage', this.isMypage ? 'true' : 'false')
      formData.append('site_flag', 'r')
      formData.append('app_flag', this.$site.appFlag)
      const app = this
      this.$axios.post(this.$varuna.endPoints.displayDialog, formData, { timeout: 60000 })
      this.$iterateStorage(function (value, key, iterationNumber) {
        // console.log all the kay/value pairs
        if (key === 'basicData') {
          app.username = value.lastName + '_' + value.firstName
        }
      }, function (err) {
        if (!err) {
          console.log('Iteration has completed')
        }
      })
      this.isNeocareerSended = false
    },
    closeNeocareerDialog: function () {
      this.$eventHub.$emit('update_rt_condition', this.clientId, this.permissionType)
      this.$modal.hide('neocareer-dialog')
      this.clearLocalStorageConfirmVisible = false

      // before-close の判定に影響しないように、送信状態のリセットは閉じた後に行う
      this.$nextTick(() => {
        this.isNeocareerSended = false
      })
      // this.$router.push('/mypage')
    },
    handleBeforeClose: function (event) {
      if (!this.isNeocareerSended) {
        this.$eventHub.$emit('update_rt_condition', this.clientId, this.permissionType)
        emitRtDialogClosedWithoutSubmit()
      }
    },
    confirmWin: function () {
      confirm('応募するデータを送信します。よろしいでしょうか。')
    },
    clearLocalStorage: function () {
      this.$clearStorage()
      window.location = '/'
    },
    createFilename: function (ext) {
      const now = new Date()
      const prefix = process.env.VUE_APP_DOWNLOAD_FILENAME_PREFIX
      const dateString = this.$formLib.dateFormat(now, '_yyyy-mm-dd_HH-MM-ss')
      return `${prefix}${this.formatid}${dateString}.${ext}`
    },
    sendNeocareerConsult: async function () {
      if (!this.isAgree) {
        this.$message({
          message: 'チェックしてから同意ボタンを押してください。',
          type: 'error'
        })
        return
      }

      if (this.isNeocareerSended) {
        return
      }
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken || !this.$firebase.user.email) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      this.fullscreenLoading = true
      const formData = this.pdfFormData
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('yaginame', this.username)
      formData.append('app_flag', this.$site.appFlag)
      formData.append('dialog_name', 'neocareer_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('filename', this.createFilename('pdf'))
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('version', '3')
      formData.append('is_mypage', this.isMypage ? 'true' : 'false')
      formData.append('reqflg', '2')
      const app = this

      if (this.permissionType == 4 || this.permissionType == 6) {
        this.$axios
          .post(this.$varuna.endPoints.sendHitoshia, formData, { timeout: 60000 })
          .then(function (response) {
            app.isNeocareerSended = true
            app.$globalVar.eventTag()
            app.$eventHub.$emit('update_rt_condition', 'hitoshia_admin', app.permissionType)
          })
          .catch(function (error) {
            app.$message({
              message: '送信失敗しました',
              type: 'error'
            })
            app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
          }).finally(function () {
            app.fullscreenLoading = false
          })
      } else {
        this.$axios
          .post(this.$varuna.endPoints.sendNeocareer, formData, { timeout: 60000 })
          .then(function (response) {
            app.isNeocareerSended = true
            app.$globalVar.eventTag()
            app.$eventHub.$emit('update_rt_condition', app.clientId, app.permissionType)
          })
          .catch(function (error) {
            app.$message({
              message: '送信失敗しました',
              type: 'error'
            })
            app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
          }).finally(function () {
            app.fullscreenLoading = false
          })
      }
    }
  },
  beforeMount: function () {
    this.$eventHub.$on('send-neocareer-consult', this.sendNeocareerConsult)
    // emitGlobalVarPopupDialog → mitt 直購読（GLOBAL_VAR_POPUP_EVENT_TYPES / emitter.js）
    this._mittGVPopup_openNeocareerDialog = wrapMittPopupHandler(this, 'openNeocareerDialog')
    this.$emitter.on('open-neocareer-dialog', this._mittGVPopup_openNeocareerDialog)
    this.$eventHub.$on('popstate', this.closeNeocareerDialog)
  },
  destroyed: function () {
    this.$eventHub.$off('send-neocareer-consult', this.sendNeocareerConsult)
    this.$emitter.off('open-neocareer-dialog', this._mittGVPopup_openNeocareerDialog)
    this.$eventHub.$off('popstate', this.closeNeocareerDialog)
  }
}
</script>
